module.exports = "https://static.wmbcdn.com/uniweb/images/f3bb54f9acc63c312374db052a1fe4fc.svg";